module.exports = __webpack_public_path__ + "9814b667f420a8db73304391621fa047.png";